import React from "react";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  container: {
    padding: [[16, 0]],
    fontSize: "0.875rem"
  },
  title: {
    marginBottom: 8,
    textTransform: "uppercase",
    fontWeight: 500,
    fontSize: "inherit"
  },
  fieldContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    paddingTop: 8,
    "&>.field": {
      marginBottom: 12,
      "&:last-child": {
        marginBottom: 0
      }
    }
  },
  message: {
    marginTop: 8,
    color: "red"
  }
});

const FieldGroup = ({ classes, children, title, error, className }) => (
  <section className={classNames(classes.container, className)}>
    {title && <p className={classes.title}>{title}</p>}
    <div className={classes.fieldContainer}>{children}</div>
    {error && (
      <div className={classes.message}>
        <small>{error}</small>
      </div>
    )}
  </section>
);

export default withStyles(styles)(FieldGroup);



// WEBPACK FOOTER //
// ./src/components/FieldGroup.js